import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestSignOut } from "application/auth/authActions";
import { requestConfirmDeleteAccount } from "application/deleteAccount/deleteAccountActions";
import { getQueryStringParam } from "helpers/queryStringHelper";
import { isFailed, isFinished } from "helpers/requestStateHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "routes";
import urlJoin from "url-join";

const confirmationTokenParamName = "confirmation-token";

export const DeleteAccountConfirmation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const deleteAccountConfirmation = useSelector(state => state.operations.deleteAccountConfirmation);
  useEffect(() => {
    const confirmationToken = getQueryStringParam(confirmationTokenParamName, location);
    dispatch(requestConfirmDeleteAccount(confirmationToken));
  }, []);

  useEffect(() => {
    if (isFinished(deleteAccountConfirmation)) {
      dispatch(requestSignOut(urlJoin(window.location.origin, routes.accountDeleted)));
    }
    if (isFailed(deleteAccountConfirmation)) {
      history.replace(routes.deleteAccountError);
    }
  }, [deleteAccountConfirmation]);

  return <Loader />;
};
